// router/index.js (optimizado)
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import LoginDisponibilidad from '../views/Docente/LoginDisponibilidad.vue'
import Disponibilidad from '../views/Docente/Disponibilidad.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home, meta: { auth: true } },
  { path: '/login', name: 'Login', component: Login, meta: { auth: false } },
  // Ruta pública específica primero (evita que la capture alguna dinámica)
  { path: '/login/disponibilidad', name: 'LoginDisponibilidad', component: LoginDisponibilidad, meta: { auth: false } },
  { path: '/disponibilidad', name: 'Disponibilidad', component: Disponibilidad, meta: { auth: true , menu:false} }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
